<template>
  <div>
    <p class="desc-info">
      <span>订单号：{{ flowInfo.orderId }}</span>
      <span>任务类型：质控</span>
      <span>当前任务状态：{{ this.$flowStatus.get(flowInfo.status) }}</span>
      <span>语种方向：{{ $sysLan.get(slan) }}-{{ $sysLan.get(tlan) }}</span>
      <el-button
        type="primary"
        icon="el-icon-document"
        size="mini"
        class="m-r-10"
        @click="toOrderDetail"
        plain
      >
        订单详情
      </el-button>
      <el-button
        size="mini"
        type="warning"
        v-if="
          (flowInfo.status === 1 ||
            flowInfo.status === 2 ||
            flowInfo.status === 3) &&
          permissions.dot_flow_submit
        "
        @click.stop="endMission()"
      >
        结束质控任务
      </el-button>
    </p>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="质控配置" name="1">
        <zkConfigure
          v-if="configInfo.status"
          :configInfo="configInfo"
          :staParams="staParams"
          :slan="slan"
          :tlan="tlan"
          @changeStatus="getStatus"
          ref="zkConfigure"
        />
      </el-tab-pane>
      <el-tab-pane
        label="质控数据"
        v-if="
          flowInfo.status !== 0 &&
          flowInfo.status !== -1 &&
          flowInfo.status !== 1 &&
          flowInfo.status !== 2
        "
        name="2"
      >
        <zkStatistics
          :flowId="$route.params.id"
          :orderId="flowInfo.orderId"
          :staParams="staParams"
          ref="zkStatistics"
        />
      </el-tab-pane>
      <el-tab-pane label="质控终稿" v-if="flowInfo.status === 4" name="3">
        <el-row>
          <el-col offset="1">
            <el-radio-group v-model="tranFromat">
              <el-radio label="1">纯译文</el-radio>
              <el-radio label="2">段段对照</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <fileDown
              v-if="this.flowInfo.orderId && slan"
              :fileOption="{ title: '终稿-未翻/通过部分为原文' }"
              :type="6"
              :tranFromat="tranFromat"
              :taskType="6"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams"
              key="qc"
              ref="qcDown"
            />
          </el-col>
          <el-col :span="24">
            <fileDown
              v-if="this.flowInfo.orderId && slan"
              :fileOption="{
                title:
                  '终稿-未翻部分为译文（未审核的还原为最后一次PE结果，未PE的还原为机翻译文）',
              }"
              :type="12"
              :taskType="6"
              :tranFromat="tranFromat"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams"
              key="excel"
              ref="qcTranDown"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane v-if="this.flowInfo.status === 4" label="平行语料" name="5">
        <el-row>
          <el-col :span="24">
            <fileDown
              v-if="this.flowInfo.orderId"
              :fileOption="{ title: '平行语料稿-未翻/通过部分为原文' }"
              :type="8"
              :taskType="6"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams"
              key="qcexcel"
              ref="qcExcelDown"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <fileDown
              v-if="this.flowInfo.orderId"
              :fileOption="{ title: '平行语料稿-未翻/通过部分为译文' }"
              :type="18"
              :taskType="6"
              :orderId="this.flowInfo.orderId"
              :staParams="staParams"
              key="peTranDown2"
              ref="peTranDown2"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="项目公告" name="6">
        <projectNotice
          ref="qcProjectNotice"
          :status="flowInfo.status"
          :id="flowInfo.id"
          :taskType="flowInfo.taskType"
          :orderId="flowInfo.orderId"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import zkConfigure from './qc-configure';
import zkConfigure2 from './qc-configure-status2';
import zkStatistics from './qc-statistics';
import projectNotice from '../components/projectNotice';
import {
  getFlowInfo,
  finish,
  checkfinishQcFlowByPm,
  getUndealtWordNum,
} from '@/api/dot/qc';
import { getObj } from '@/api/dot/order';
import { statistics } from '@/api/dot/flow';
import fileDown from '@/views/common/fileDown';
import { mapGetters, mapState } from 'vuex';
import { alertErroMsg, alertSuccessMsg } from '@/util/commonMsg';

export default {
  components: {
    zkConfigure,
    zkConfigure2,
    zkStatistics,
    fileDown,
    projectNotice,
  },
  data() {
    return {
      tranFromat: '1',
      activeName: '1',
      flowInfo: {},
      configInfo: {},
      page: false,
      slan: '',
      tlan: '',
      qcData: [],
      qcName: '',
      staParams: null,
    };
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  created: function () {
    this.flowInfo = {};
    this.configInfo = {};
    getFlowInfo(this.$route.params.id).then((response) => {
      this.flowInfo = response?.data?.data;
      let orderTag = null;
      if (this.flowInfo?.orderId) {
        getObj(this.flowInfo.orderId).then((res) => {
          const data = res?.data?.data || {};
          this.slan = data.slan;
          this.tlan = data.tlan;
          orderTag = data.orderTag;
          this.tranFromat = data.tranFormat + '';
          let tempConfig = this.flowInfo;
          if (this.flowInfo.qcConfigDto) {
            tempConfig = this.flowInfo.qcConfigDto;
          }
          tempConfig.limitTime = this.flowInfo.limitTime;
          tempConfig.wordsCount = this.flowInfo.wordsCount;
          tempConfig.rowCount = this.flowInfo.rowCount;
          tempConfig.qcList = this.flowInfo.userWebVos;
          tempConfig.status = this.flowInfo.status;
          tempConfig.orderTag = orderTag;
          tempConfig.isMtOut = data.isMtOut;
          tempConfig.peEndTime = this.flowInfo.peEndTime;
          tempConfig.isConfigDisabled = this.flowInfo.status !== 1;
          tempConfig.isQcCanChoose =
            this.flowInfo.status === 1 || this.flowInfo.status === 2;
          tempConfig.orderId = this.flowInfo.orderId;
          this.configInfo = tempConfig;
          this.qcName = '';
        });
      }
    });
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '质控任务详情',
    };
  },
  mounted() {
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 接收子组件（质控配置）传过来的值
    getStatus(val) {
      this.flowInfo.status = 1;
    },

    toOrderDetail() {
      this.$router.push({ path: '/dot/order/detail/' + this.flowInfo.orderId });
      statistics(
        Object.assign(
          {
            event_name: '订单详情',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    handleClick(tab, event) {
      if (tab.name === '2') {
        this.$refs.zkStatistics.init();
      } else if (tab.name === '3') {
        this.$refs.qcDown.init();
        this.$refs.qcTranDown.init();
        this.$refs.qcExcelDown.init();
      } else if (tab.name === '5') {
        this.$refs.qcExcelDown.init();
        this.$refs.peTranDown2.init();
      } else if (this.activeName === '6') {
        this.$refs.qcProjectNotice.getNotice();
      }
    },
    endMission() {
      getUndealtWordNum({
        orderId: this.flowInfo.orderId,
      }).then((res) => {
        const surplusWord = res.data?.data?.wordCountUndealed;
        if (surplusWord > 0) {
          let msg = `<div><p>系统检测到此订单有未分配质控的字数，稿件将有内容无人质控！</p><p>  同时现有质控任务还在进行中，此时结束任务，可能造成项目风险。</p><p>  说明：（现有质控成本仍按照质控领取任务金额结算）</p><p class='m-t-10 f-w-600'>确定结束质控任务？</p></div>`;
          this.$confirm(msg, '质控任务风险提醒', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
          })
            .then(() => {
              this.finishQc();
            })
            .catch(() => {});
        } else {
          checkfinishQcFlowByPm({ flowId: this.$route.params.id }).then(
            (res) => {
              let code = res.data.data;
              if (code === 1) {
                let text =
                  '质控任务还在进行中，此时结束任务，可能造成项目风险，确定结束任务？<br> PS:质控成本仍按照质控领取任务金额结算';
                this.$alert(text, {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  showCancelButton: true,
                  dangerouslyUseHTMLString: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      //结束QC
                      this.finishQc();
                    } /* else {
								this.$router.replace('/refresh')
							} */
                  },
                });
              } else if (code === 0) {
                //结束QC
                this.finishQc();
              }
            },
          );
        }
      });
    },

    finishQc() {
      finish(this.$route.params.id).then((res) => {
        if (res.data.data === 1) {
          alertSuccessMsg();
        } else if (res.data.data === -4) {
          alertErroMsg('PE任务还在进行中，不能结束质控任务');
        } else {
          alertErroMsg();
        }
      });
    },
  },
  filters: {},
};
</script>
<style lang="scss" scoped>
.avue-view {
  background: #ffffff;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}
</style>
